import React from 'react';
import styles from './styles.css';
import DirectRolloverCard from './DirectRolloverCard';
import IndirectRolloverCard from './IndirectRolloverCard';

const Contents = () => (
  <div className="grid-container">
    <div data-e2e="direct-card" className="grid-item">
      <DirectRolloverCard />
    </div>
    <div data-e2e="indirect-card" className="grid-item">
      <IndirectRolloverCard />
    </div>
    <style jsx>{styles}</style>
  </div>
);

export default Contents;
